import React from 'react';

import { FmFormFlowDialog } from '../FmFormFlowDialog';
import type { FmAnalysisWorkspaceDescriptor } from '../FmAnalysisWorkspaceRoot.types';

/** Nested FormFlow capabilities whose descriptors were validated by the analysis archetype. */
export const AnalysisWorkspaceDialogs: React.FC<{
  descriptor: FmAnalysisWorkspaceDescriptor;
}> = ({ descriptor }) => (
  <>
    {(descriptor.dialogs ?? []).map((dialog) => (
      <FmFormFlowDialog
        key={dialog.id}
        open={dialog.open}
        title={dialog.title}
        closeLabel={dialog.closeLabel}
        size={dialog.size}
        descriptor={dialog.flow}
        closeConfirmation={dialog.closeConfirmation}
        onClose={() =>
          descriptor.onEvent?.({
            kind: 'dialog-dismiss',
            dialogId: dialog.id,
          })
        }
        data-testid={`analysis-dialog-${dialog.id}`}
      />
    ))}
  </>
);

AnalysisWorkspaceDialogs.displayName = 'AnalysisWorkspaceDialogs';
